export default function JackpotsFilter (className) {

    let elements  = document.getElementsByClassName(className);

    if (!elements.length) return;

    this.filterCountries = function(filter) {

        [].forEach.call(elements, function (el){

            if(filter=="all") {
                el.filteredByCountry = false;
            }else if (el.classList.contains('filter_' + filter)) {

                el.filteredByCountry = false;
            }else {
                el.filteredByCountry = true;
            }

            if(!el.filteredByCountry && !el.filteredByName) {
                el.style.display = '';
            }else {
                el.style.display = 'none';
            }

        });

    }

    this.filterNames = function(filter) {

        filter = filter.trim();

        [].forEach.call(elements, function (el) {
            let searchText = el.getElementsByClassName("filter_text")[0].innerHTML.toUpperCase();
 
            if (searchText.indexOf(filter) > -1) {
                el.filteredByName = false;
            } else {
                el.filteredByName = true;
            }

            if(!el.filteredByCountry && !el.filteredByName) {
                el.style.display = '';
            }else {
                el.style.display = 'none';
            }

        });
    }
}


// WEBPACK FOOTER //
// ./js/src/JackpotsFilter.js